import Center from "@/Components/Base/Center";
import KioskLogo from "./KioskLogo";
import Button from "@/Components/Button/Button";
import { useCart } from "@/shared/hooks/useCartHook";
import { deliveryMethodsEnum } from "@/shared/utils/constant";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useParams } from "react-router-dom";
import KioskCartItem from "./KioskCartItem";

const KioskCheckout = () => {
  const [cart] = useCart();
  const { t } = useTranslation("", { keyPrefix: "kioskPage" });
  const { t: tCommon } = useTranslation("");

  const { id } = useParams<{ id: string }>();
  const method = deliveryMethodsEnum[id];
  const history = useHistory();

  useEffect(() => {
    if (cart.length === 0) {
      return history.push("/kiosk");
    }
  }, [cart]);

  return (
    <Center>
      <div>
        <div className="mb-[2rem]">
          <div>
            <KioskLogo height="auto" width="50rem" />
          </div>
        </div>
        <h1 className="mb-[4rem] text-[6rem]">
          {t("isOrderCorrect")}
        </h1>
        <h2 className="text-[4rem]">
          {t(`my${method}`)}
        </h2>
        <div className="cursor-pointer">
          {cart.map((item, i) => (
            <div key={i} className="mb-[2rem]">
              <KioskCartItem index={i} cartItem={item} />
            </div>
          ))}
        </div>
        <div className="flex justify-between gap-8">
          <Link to={`/kiosk/menu/${id}/payment`}>
            <Button>
              <div className="text-[4rem]">{tCommon("yesPay")}</div>
            </Button>
          </Link>

          <Button>
            <div onClick={() => history.goBack()} className="text-[4rem]">
              {tCommon("noGoBack")}
            </div>
          </Button>
        </div>
      </div>
    </Center>
  );
};

export default KioskCheckout;
